<div
  class="upload-dropzone"
  [class.dragging]="isDragging()"
  [class.disabled]="disabled()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">
  <mat-icon>cloud_upload</mat-icon>
  <span>Drag and drop files here or</span>
  <button
    mat-stroked-button
    color="primary"
    (click)="onBrowseClick()"
    [disabled]="disabled()">
    Browse Files
  </button>
  <input
    #fileInput
    type="file"
    multiple
    hidden
    (change)="onFileSelect($event)" />
</div>
